// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { xBaseTheme } from "@rc/XDL/types";
import { color, xScreen } from "@rc/XDL/Utilities";
import { css } from "styled-components";

const tabBorderStyle = (withBorder: boolean) => css`
    &::after {
        content: "";
        height: 1px;
        display: block;
        background: ${withBorder ? color("common.ui3") : "transparent"};
        width: 100%;
        position: absolute;
        left: 0;
        bottom: 0;
    }
`;

const tabSelectedStyle = css`
    border-bottom: 4px solid ${color("primary.main")} !important;
    color: ${color("primary.main")};
    z-index: 999;
    span {
        color: ${color("primary.main")};
    }
`;

const tabStyle = css`
    padding: 9px 32px;
    font-size: 16px;
    width: auto;
    background: transparent;
    border-radius: 0;
    border: none;
    border-bottom: 4px solid transparent;
    -webkit-animation: fadeInRight 0.6s forwards;
    animation: fadeInRight 0.6s forwards;
    -webkit-transition: all 0.2s ease;
    transition: all 0.2s ease;
    color: ${color("common.ui10")};
    text-align: center;
    font-weight: 300;
    text-decoration: none;
    cursor: pointer;
    position: relative;
    text-transform: none;
    &:hover {
        border-color: transparent;
        border-width: 4px;
        color: ${color("primary.main")};
    }
    &:focus {
        border-color: transparent;
        color: ${color("primary.main")};
        outline: none;
    }
    &:focus-visible:not(:disabled) {
    }
`;

export default {
    defaultProps: {
        mergeCss: true,
        typographyProps: {
            size: 16,
            css: css`
                letter-spacing: 0;
                line-height: 24px;
            `,
        },
        css: css`
            ${tabStyle}
            ${({ selected }: any) => selected && tabSelectedStyle}
        `,
    },
    groupDefaultProps: {
        mergeCss: true,
        cssOverrides: {
            tabGroup: css`
                ${({ withBorder }: any) => tabBorderStyle(withBorder)}
                position: relative;
                padding: 0;
                align-items: center;
                font-size: 16px;
            `,
            wrapper: css`
                width: 100%;
                padding: 0;
            `,
            tabContent: css`
                padding: 30px 0;
                margin-top: 0;
                border: 0;
                ${xScreen("gt", "md")} {
                }

                ${xScreen("lte", "md")} {
                }

                @media print {
                    & > ${TypographyStyle} {
                        display: inline-block;
                        ${tabStyle}
                        ${tabSelectedStyle}
                    }
                }
            `,
        },
    },
} as xBaseTheme["tab"];
